// Note: if you change a regex here make sure you change their back-end counterparts also: Constants/Regex.php

export const CUSTOMER_CODE = /^\d{10}$/;
export const PRODUCT_CODE = /^[0-9A-Z]*$/;
export const PRODUCT_CODES = /^[0-9A-Z]+(,[0-9A-Z]*)*\b$/;
export const SAP_CODE = /[0-9]+$/;
export const POSITIVE_NUMBER = /^[1-9]\d*$/;
